import React from 'react';
import { shape, object, string } from 'prop-types';
import { Card, Container, Stack } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { Heading, Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { getCarouselHref } from '../../gigs/GigsComponentsWrapper/CarouselLink/utils';
import { textEllipsis } from './ErrorState.ve.css';
import { CARD_MARGIN_TOP } from './constants';
import { getCardHeight } from './utils';

export const ErrorState = ({ title, subtitle, buttonData, dataEnrichment }) => {
    const hasText = title || subtitle;
    const buttonHref = buttonData && getCarouselHref(buttonData, dataEnrichment);

    return (
        <Card height={getCardHeight()} minWidth="350px" marginTop={CARD_MARGIN_TOP}>
            <Stack
                alignItems="center"
                minHeight={getCardHeight()}
                paddingLeft="12"
                paddingRight="12"
                height="100%"
                justifyContent={{
                    default: 'center',
                    sm: 'spaceBetween',
                }}
                direction={{
                    default: 'columnReverse',
                    sm: 'row',
                }}
                gap={{
                    default: '6',
                    sm: '3',
                }}
            >
                <Stack
                    gap="6"
                    direction="column"
                    alignItems={{
                        default: 'center',
                        sm: 'flexStart',
                    }}
                >
                    {hasText && (
                        <Stack direction="column">
                            {title && (
                                <Heading as="h4" className={textEllipsis}>
                                    {title}
                                </Heading>
                            )}
                            {subtitle && <Text className={textEllipsis}>{subtitle}</Text>}
                        </Stack>
                    )}
                    {buttonData && (
                        <Container width="fit-content">
                            <Button href={buttonHref} target="_blank">
                                {buttonData?.value}
                            </Button>
                        </Container>
                    )}
                </Stack>
                <Image
                    height="97px"
                    width="205px"
                    src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/fd5de73ad0986256f4c0839952dff5c2-1699526063162/image.png"
                    alt="empty carousel image"
                />
            </Stack>
        </Card>
    );
};

ErrorState.propTypes = {
    buttonData: shape({
        url: string,
        namedRoute: string,
        urlParams: object,
        queryParams: object,
        value: string,
    }),
    dataEnrichment: shape({
        sourceComponent: string,
        sourcePage: string,
        queryParameters: object,
    }),
    title: string,
    subtitle: string,
};
